import React from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Contact from './components/Contact';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import AnimatedSection from './components/motion/AnimatedSection';

function App() {
  return (
    <div className="app-root">
      <div className="app-live-bg" aria-hidden />
      <Navbar />

      <main className="app-main">
        <Hero />
        <AnimatedSection delay={0.05}>
          <About />
        </AnimatedSection>
        <AnimatedSection delay={0.08}>
          <Projects />
        </AnimatedSection>
        <AnimatedSection delay={0.1}>
          <Skills />
        </AnimatedSection>
        <AnimatedSection delay={0.12} style={{ alignSelf: 'stretch' }}>
          <Contact />
        </AnimatedSection>
      </main>
      <ScrollToTop />
    </div>
  );
}

export default App;
